import { BASE_URL } from "@/services/api/base";

export const getRequestEndpoint = `${BASE_URL}/LoaRequest/GetRequest`;
export const getRequestSubmitEndpoint = `${BASE_URL}/LoaRequest/Submit`;
export const getCancelRequestEndpoint = `${BASE_URL}/LoaRequest/CancelLoaRequest`;
export const getUpdateRequestEndpoint = `${BASE_URL}/LoaRequest/UpdateLoaRequest`;
export const getAreasEndpoint = `${BASE_URL}/Areas/Get`;

export const getPurposeEndpoint = `${BASE_URL}/Purpose/Get`;
